/* eslint-disable @next/next/no-img-element */
import Button from "components/general/buttonv2";
import Link from "next/link";
import styled from "styled-components";

const StyledSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledWrapper = styled.div`
  line-height: 1.5;
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  align-items: center;
  padding: 1rem 2rem;
  margin-bottom: 2rem;
  h2 {
    font-size: 3rem;
    line-height: 4.2rem;
    font-weight: 700;
    width: 100%;
    text-align: center;
    margin-bottom: 0;
    @media screen and (max-width: 1280px) {
      margin: 2rem 0 0 0;
    }
    @media screen and (max-width: 992px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
    @media screen and (max-width: 768px) {
      text-align: left;
    }
  }
  p {
    text-align: center;
    font-size: 1.2rem;
    line-height: 2rem;
    margin-bottom: 4rem;
    @media screen and (max-width: 768px) {
      text-align: left;
      margin-bottom: 1rem;
    }
  }
  @media screen and (max-width: 768px) {
    margin-bottom: 0;
    h2 {
      text-align: center;
    }
  }
`;

const StyledContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props["data-reverse"] ? "row-reverse" : "row")};
  align-items: center;
  gap: 5rem;
  margin-bottom: 4rem;
  h2 {
    line-height: 4rem;
    font-size: 3.375rem;
    font-weight: 700;
    @media screen and (max-width: 1280px) {
      margin: 2rem 0 0 0;
    }
    @media screen and (max-width: 992px) {
      line-height: 4.2rem;
      font-size: 3rem;
    }
  }
  p {
    font-size: 1.2rem;
    line-height: 2rem;
  }
  @media screen and (max-width: 992px) {
    display: block;
  }
`;
const StyledRight = styled.div`
  flex: 1.2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

const StyledBlock = styled.div`
  border-radius: 10px;
  overflow: hidden;
  flex: 1;
  svg {
    max-width: 100%;
    margin-bottom: 1.5rem;
  }
`;
const StyledContent = styled.div`
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 1rem;
  }

  @media screen and (max-width: 768px) {
    text-align: center;
  }
`;
const StyledLabel = styled.div`
  font-weight: 700;
  font-size: 1.6rem;
`;

const StyledGradientSpan = styled.span`
  background: linear-gradient(270deg, #7551cb 3.49%, #5172c8 92.38%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const SubHero = () => {
  return (
    <StyledSection>
      <StyledWrapper>
        <h2 style={{ marginBottom: "5rem" }}>Start Deleting in 3 Simple Steps</h2>
        <StyledContainer>
          <StyledRight>
            <img
              src="/images/how-it-works/1.png"
              alt="Simply download the application on desktop or mobile"
            />
          </StyledRight>
          <StyledBlock>
            <StyledContent>
              <div
                style={{
                  fontSize: "4rem",
                  lineHeight: "1.5",
                  color: "#604AFF",
                }}
              >
                01
              </div>
              <StyledLabel>
                <StyledGradientSpan>Download</StyledGradientSpan> the application on desktop or
                mobile.
              </StyledLabel>
              <div>
                Download the Redact application on your preferred device. For the full range of
                features, we recommend using the desktop client. Redact operates locally, ensuring
                your data remains securely on your machine.
              </div>
              <Button alignSelf="center" to="/download">
                Download
              </Button>
            </StyledContent>
          </StyledBlock>
        </StyledContainer>

        <StyledContainer data-reverse={true}>
          <StyledRight>
            <img
              src="/images/how-it-works/2.png"
              alt="Simply download the application on desktop or mobile"
            />
          </StyledRight>
          <StyledBlock>
            <StyledContent>
              <div
                style={{
                  fontSize: "4rem",
                  lineHeight: "1.5",
                  color: "#604AFF",
                }}
              >
                02
              </div>
              <StyledLabel>
                <StyledGradientSpan>Connect</StyledGradientSpan> to your desired platforms.
              </StyledLabel>
              <div>
                Connect each service individually, or use our browser import function to quickly log
                in to all your accounts.
                <br />
                <br />
                We believe that privacy is a universal right.
                <br />
                <br />
                We cannot see, store, or interact with your data or login information. All logins
                are securely handled directly by the platforms.
                <br />
                <br />
                Please note, some platforms do require <Link href="/login">Redact Premium.</Link>
              </div>
            </StyledContent>
          </StyledBlock>
        </StyledContainer>

        <StyledContainer>
          <StyledRight>
            <img
              src="/images/how-it-works/3.png"
              alt="Simply download the application on desktop or mobile"
            />
          </StyledRight>
          <StyledBlock>
            <StyledContent>
              <div
                style={{
                  fontSize: "4rem",
                  lineHeight: "1.5",
                  color: "#604AFF",
                }}
              >
                03
              </div>
              <StyledLabel>
                Manage Your <StyledGradientSpan>Digital Footprint!</StyledGradientSpan>
              </StyledLabel>
              <div>
                Select from a variety of content, filters and deletion methods to meet your privacy
                needs. With Redact’s versatile deletion tools, you can delete and manage a range of
                content.
                <br />
                <br />
                Run your redactions with filters for:
                <br />• Keywords (spicy, sensitive, or otherwise)
                <br />• Hashtags (#cancelme)
                <br />• Timeframe
                <br />• Content type
                <br />• Many more
                <br />
                <br />
                Or, you can just select ‘everything’ and start fresh.
              </div>
            </StyledContent>
          </StyledBlock>
        </StyledContainer>
      </StyledWrapper>
    </StyledSection>
  );
};

export default SubHero;
